import React from 'react';
import FilePDFIcon from '@/assets/svg/FilePDF.svg';
import FileJPEGIcon from '@/assets/svg/FileJPEG.svg';
import FileJPGIcon from '@/assets/svg/FileJPG.svg';
import FilePNGIcon from '@/assets/svg/FilePNG.svg';
import FileDOCXIcon from '@/assets/svg/FileDOCX.svg';

/**
 * Pick a file-type icon from the filename extension (CR-local copy of the
 * service-request helper, kept here to preserve epic boundaries). Defaults to
 * the PDF icon for unknown/missing extensions.
 */
export const getFileIcon = (filename: string): React.ReactNode => {
  const ext = filename.split('.').pop()?.toLowerCase();
  switch (ext) {
    case 'jpeg':
      return <FileJPEGIcon className="w-9 h-9 shrink-0" />;
    case 'jpg':
      return <FileJPGIcon className="w-9 h-9 shrink-0" />;
    case 'png':
      return <FilePNGIcon className="w-9 h-9 shrink-0" />;
    case 'docx':
      return <FileDOCXIcon className="w-9 h-9 shrink-0" />;
    default:
      return <FilePDFIcon className="w-9 h-9 shrink-0" />;
  }
};
